export const ellipsizetext = (input) => {
    return input.length < 30 ? input : input.slice(0,30)+"...";
}